import { Component, Inject, Input, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ConfigServiceService } from 'src/app/services/config-service.service';
import { SizeChartService } from 'src/app/services/size-chart.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'calsoft-size-chart',
  templateUrl: './size-chart.component.html',
  styleUrls: ['./size-chart.component.scss']
})
export class SizeChartComponent implements OnInit {

  @Input() imgValue: any;
  
  @Input()  type:any;

  @Input()  data:any;

  @Input()  sizeId:any;


  sizeChart: any;
  sizeChartList: any;
  sizeChartName: any;
  value: any;
  name: any;
  description: any;

  constructor(private configService:ConfigServiceService,
    private dialogRef: MatDialogRef<SizeChartComponent>,
    @Inject(MAT_DIALOG_DATA) data,
    private sizeChartService: SizeChartService) {

      this.sizeId=data.sizeChartId;
      this.name=data.name;
      this.getSizeChart(this.sizeId);
     }


  public serverPath = environment.commonImageApi + "sizeChart/";

  ngOnInit(): void {

  }




  getSizeChart(sizeId: number) {
    this.sizeChartService.getSizeChart(this.sizeId).subscribe(
      (res: any) => {
         this.sizeChartList = res;
        console.log(this.sizeChartList);


        this.imgValue=this.sizeChartList['imgValue']
        this.type=this.sizeChartList['type']
        this.sizeChartName=this.sizeChartList['sizeChartName']
        this.description=this.sizeChartList['description']

        if(this.type==1){

          if(this.sizeChartList['value']!=undefined){
            this.value=JSON.parse(this.sizeChartList['value'])
          }
          
        }
        
        
          },
          (error: any) => {
            console.error(error);
          }
        );
  }

  close(){
    this.dialogRef.close();
  }

}
